// extracted by mini-css-extract-plugin
module.exports = {"rules-modal":"RulesModal_rules-modal__42O1U"};